<fd-side-nav [condensed]="condensed">
  <div fd-side-nav-main>
    @if (!condensed) {
      <div class="atom-header-top">
        <a routerLink="/" class="atom-nav-home"></a>
      </div>
    }

    <ul fd-nested-list [fdCompact]="false" [textOnly]="false">
      @for (navigationItem of sideNavMain; track navigationItem) {
        @if (navigationItem.featureToggle | isFeatureEnabled) {
          <li fd-nested-list-item  >
            <a fd-nested-list-link (click)="onPageClick(navigationItem.route || '')" class="atom-navigation-item"
              [selected]="navigationItem.isSelected"
              [class.nav-item-selected]="navigationItem.isSelected">
              <div class="icon-wrapper" [title]="condensed ? navigationItem.title : ''">
                @if (navigationItem.iconType === IconType.FontAwesome) {
                  <app-icon [icon]="$any(navigationItem.icon)" size="lg" class="fa-icon"></app-icon>
                } @else {
                  @if (navigationItem.iconType !== 'cad') {
                    <fd-icon fd-nested-list-icon [font]="$any(navigationItem.iconType)" [glyph]="navigationItem.icon">
                    </fd-icon>
                  }
                  @if (navigationItem.iconType === 'cad') {
                    <cad-icon-component></cad-icon-component>
                  }
                }
              </div>
              <span fd-nested-list-title class="nav-item-text">{{ navigationItem.title }}</span>
            </a>
          </li>
        }
      }
    </ul>
  </div>
</fd-side-nav>
